const votersToDisable = new Set<string>()

export function voteToDisableIframePointerEvents(voterId: string, voteIntent: "disable" | "enable") {
  if (voteIntent === "disable") {
    votersToDisable.add(voterId)
  } else {
    votersToDisable.delete(voterId)
  }

  update()

  function update() {
    const hasAtLeastOneVote = votersToDisable.size > 0
    document.querySelectorAll('iframe').forEach((iframe) => {
      iframe.dataset.disablePointerEvents = hasAtLeastOneVote ? "true" : "false"
    })
  }
}
